import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";

// Public Pages
import { HomePage } from "./pages/HomePage";
import { AboutPage } from "./pages/AboutPage";
import { ServicesPage } from "./pages/ServicesPage";
import { NewsPage, BlogDetailPage } from "./pages/NewsPage";
import { ProcessPage } from "./pages/ProcessPage";
import { ContactPage } from "./pages/ContactPage";
import { DynamicPage } from "./pages/DynamicPage";

// Admin Pages
import {
  AdminAuthProvider,
  AdminLogin,
  AdminDashboard,
  AdminPages,
  AdminBlogs,
  AdminGalleries,
  AdminNavigation,
  AdminTopics,
  AdminSubmissions,
  AdminServiceBoxes,
  AdminUsers,
} from "./pages/admin";

// Intercept clicks on internal links in CMS-rendered content so they use client-side routing
const InternalLinkHandler = ({ children }) => {
  const navigate = useNavigate();
  useEffect(() => {
    const handleClick = (e) => {
      // Only handle links inside CMS prose content — not React Router <Link>s
      const anchor = e.target.closest("a[href]");
      if (!anchor) return;
      if (!anchor.closest(".prose-content")) return;
      const href = anchor.getAttribute("href");
      if (href && href.startsWith("/") && !href.startsWith("//")) {
        e.preventDefault();
        navigate(href);
      }
    };
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, [navigate]);
  return children;
};

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <InternalLinkHandler>
          <Toaster
            position="top-right"
            toastOptions={{
              style: {
                background: "#0a1e26",
                color: "#F7F7F5",
                border: "1px solid rgba(63, 167, 163, 0.2)",
              },
            }}
          />
          <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/news/:slug" element={<BlogDetailPage />} />
          <Route path="/process" element={<ProcessPage />} />
          <Route path="/contact" element={<ContactPage />} />

          {/* Admin Routes */}
          <Route
            path="/monkey"
            element={
              <AdminAuthProvider>
                <AdminLogin />
              </AdminAuthProvider>
            }
          />
          <Route
            path="/monkey/dashboard"
            element={
              <AdminAuthProvider>
                <AdminDashboard />
              </AdminAuthProvider>
            }
          />
          <Route
            path="/monkey/pages"
            element={
              <AdminAuthProvider>
                <AdminPages />
              </AdminAuthProvider>
            }
          />
          <Route
            path="/monkey/blogs"
            element={
              <AdminAuthProvider>
                <AdminBlogs />
              </AdminAuthProvider>
            }
          />
          <Route
            path="/monkey/galleries"
            element={
              <AdminAuthProvider>
                <AdminGalleries />
              </AdminAuthProvider>
            }
          />
          <Route
            path="/monkey/navigation"
            element={
              <AdminAuthProvider>
                <AdminNavigation />
              </AdminAuthProvider>
            }
          />
          <Route
            path="/monkey/topics"
            element={
              <AdminAuthProvider>
                <AdminTopics />
              </AdminAuthProvider>
            }
          />
          <Route
            path="/monkey/submissions"
            element={
              <AdminAuthProvider>
                <AdminSubmissions />
              </AdminAuthProvider>
            }
          />
          <Route
            path="/monkey/service-boxes"
            element={
              <AdminAuthProvider>
                <AdminServiceBoxes />
              </AdminAuthProvider>
            }
          />
          <Route
            path="/monkey/users"
            element={
              <AdminAuthProvider>
                <AdminUsers />
              </AdminAuthProvider>
            }
          />

          {/* Dynamic CMS Pages (catch-all — must be last) */}
          <Route path="/*" element={<DynamicPage />} />
        </Routes>
          </InternalLinkHandler>
        </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
